import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import convertAttributesToMarks from '../../utils/convertAttributesToMarks';
export default function insertText(editor, text) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      entity = _ref.entity,
      markAttributes = _objectWithoutProperties(_ref, ["entity"]);

  var marks = convertAttributesToMarks(markAttributes);

  if (entity) {
    var _ref2 = entity || {},
        type = _ref2.type,
        data = _ref2.data;

    var parentInline = editor.value.document.getClosestInline(editor.value.selection.start.key);

    if (parentInline && data.entityId === parentInline.getIn(['data', 'entityId'])) {
      return editor.insertText(text, marks);
    }

    if (editor.value.selection.start.offset === 0) {
      var previousInline = editor.value.document.getPreviousSibling(editor.value.selection.start.key);

      if (previousInline && data.entityId === previousInline.getIn(['data', 'entityId'])) {
        return editor.moveTo(previousInline.getLastText().key).moveToEndOfText().insertText(text, marks).moveToStartOfNextText();
      }
    }

    return editor.insertInline({
      type: type,
      data: data,
      nodes: [{
        object: 'text',
        text: text,
        marks: marks
      }]
    }).moveToStartOfNextText();
  }

  return editor.insertText(text, marks);
}